// Supporter tiers — "The Forge".
//
// Players who spend money on the scene fuel the prize pool, so the tiers are
// themed as escalating fire: the more you back, the brighter you burn. Admins
// can rename / re-threshold / add / delete tiers via the Supporters admin page;
// the entries below are only the seed defaults used to bootstrap the
// `supporterTiers` collection (and as a fallback when none exist yet).

// Accent → Tailwind classes. `glow` adds the animated heat halo (see
// tailwind.config.js `tier-glow`). Keys map to existing design tokens only —
// no raw hex/rgb, per DESIGN.md.
export const TIER_ACCENTS = {
  muted: { text: 'text-muted-foreground', border: 'border-border', glow: false },
  silver: { text: 'text-silver', border: 'border-silver/50', glow: false },
  bronze: { text: 'text-bronze', border: 'border-bronze/50', glow: false },
  warning: { text: 'text-warning', border: 'border-warning/50', glow: false },
  heat: { text: 'text-heat', border: 'border-heat/50', glow: false },
  gold: { text: 'text-gold', border: 'border-gold/60', glow: true },
};

export const DEFAULT_ACCENT = 'muted';

export const tierAccent = (accent) => TIER_ACCENTS[accent] || TIER_ACCENTS[DEFAULT_ACCENT];

// Seed tiers, ascending by spend. `glow: true` turns on the animated halo.
export const DEFAULT_TIERS = [
  { name: 'Spark', minSpend: 10, accent: 'silver', glow: false },
  { name: 'Ember', minSpend: 50, accent: 'bronze', glow: false },
  { name: 'Blaze', minSpend: 150, accent: 'warning', glow: false },
  { name: 'Inferno', minSpend: 400, accent: 'heat', glow: false },
  { name: 'Supernova', minSpend: 1000, accent: 'heat', glow: true },
];

// Returns the highest tier whose threshold the spend meets, or null if the
// player is below the first tier. `tiers` may come from Firestore or defaults.
export const resolveTier = (spend, tiers = DEFAULT_TIERS) => {
  const amount = Number(spend) || 0;
  if (amount <= 0) return null;
  const sorted = [...tiers].sort((a, b) => (a.minSpend || 0) - (b.minSpend || 0));
  let match = null;
  for (const t of sorted) {
    if (amount >= (Number(t.minSpend) || 0)) match = t;
    else break;
  }
  return match;
};
